import { api } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/notifications',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function markRecived(ctx, data) {
  try {
    const response = await api({
      url: '/notifications/mark-received',
      method: 'POST',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function read(ctx, data) {
  try {
    const response = await api({
      url: `/notifications/${data.id}/read`,
      method: 'POST',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function remove(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: `/notifications/${queryParams.id}/delete`,
      method: 'DELETE'
    })
    return response
  } catch (e) {
    throw e
  }
}
